import { useState } from 'react';
import { EditorHead } from './editor-head';
import { EditorTabRail } from './editor-tab-rail';
import { EditorRightRail } from './editor-right-rail';
import { BasicInfoTab } from './basic-info';
import { ConditionsTab } from './conditions';
import { ActionsStack } from './actions';

export type EditorTab = 'basic' | 'conditions' | 'actions';

/**
 * 3-column editor layout: sticky tab rail (left), active-tab body (center),
 * sticky right rail. The single RHF form (provided by the page, with
 * shouldUnregister:false) spans all three tabs so switching preserves values.
 */
export function EditorShell() {
	const [tab, setTab] = useState<EditorTab>('basic');

	return (
		<div className="flex flex-col gap-4">
			<EditorHead />
			<div className="grid grid-cols-[200px_1fr_320px] items-start gap-4">
				<div className="sticky top-3">
					<EditorTabRail activeTab={tab} onTabChange={setTab} />
				</div>
				<div>
					{tab === 'basic' && <BasicInfoTab />}
					{tab === 'conditions' && <ConditionsTab />}
					{tab === 'actions' && <ActionsStack />}
				</div>
				<div className="sticky top-3">
					<EditorRightRail activeTab={tab} />
				</div>
			</div>
		</div>
	);
}
